module.exports = __webpack_public_path__ + "static/media/process_gears_vnt.5682dc50.png";